import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPhotoPageListDataRequest, getPhotoPageListImagesRequest } from "../api/photo-api"
import type { PhotoImageData } from "../dto/photo-dto"
import { Grid, Paper } from "@mui/material";
import LazyImage from "../components/LazyImage";

const Photos = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { year = "", set = "" } = useParams<{ year: string; set: string }>();
    const [title, setTitle] = useState<string | undefined>(undefined);
    const [images, setImages] = useState<PhotoImageData[]>([]);

    useEffect(() => {
        const fetchPageData = async () => {
            try {
                const data = await getPhotoPageListDataRequest(year, set);
                setTitle(data.title ?? t(data.titleKey));
            } catch (err: any) {
                
            }
        };

        const fetchImages = async () => {
            try {
                const data = await getPhotoPageListImagesRequest(year, set);
                setImages(data);
            } catch (err: any) {
                
            }
        };
        
        fetchPageData();
        fetchImages();
    }, [year, set]);

    const showImage = (imagePath: string, position: number) => {
        if (!imagePath) return;

        const pathArray = imagePath.split("/");
        if (pathArray.length < 2) return;

        navigate(`/photos/detail/${pathArray[0]}/${pathArray[1]}/${position}`);
    }

    return (
        <>
            <h2 style={{ margin: 0 }}>{title}</h2>

            <Grid
            container
            spacing={2}
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
            }}
            >
            {images.map((src, index) => (
                <Grid key={index} sx={{ display: "flex" }}>
                <Paper
                    sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    }}
                >
                    <LazyImage
                    key={src.thumb}
                    thumb={src.thumb}
                    onClick={() => showImage(src.thumb, index + 1)}
                    />
                </Paper>
                </Grid>
            ))}
            </Grid>
        </>
    );
};

export default Photos;
